import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import { makeStyles } from "@material-ui/core/styles";
import ClipLoader from "react-spinners/ClipLoader";
import Slider from "react-slick";
import { confirmAlert } from 'react-confirm-alert';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

import api from "../../services/api";
import 'react-calendar/dist/Calendar.css';
import "./calendar.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-confirm-alert/src/react-confirm-alert.css';

import moment from 'moment-timezone';
import 'moment/locale/pt-br';
moment.locale('pt-br');

let baseURL = process.env.REACT_APP_API_DEV;
if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  baseURL = process.env.REACT_APP_API_PROD;
}
else if (process.env.REACT_APP_ENVIRONMENT === 'staging') {
  baseURL = process.env.REACT_APP_API_STAG;
}

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },

  cardTitleWhite: {
    height: '22px',
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '22px',
    textAlign: 'center'
  },

  container: {
    justifyContent: 'center',
    alignItems: 'center'
  },

  company: {
    height: '38px',
    color: '#BDBDBD',
    fontFamily: "Open Sans",
    fontSize: '14px',
    lineHeight: '19px',
    textAlign: 'center'
  },

  hora: {
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '30px',
    lineHeight: '20px',
    textAlign: 'center',
    fontWeight: '600',
    marginTop: '67px'
  },

  dayInfo: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    lineHeight: '16px',
    textAlign: 'center'
  },

  button: {
    borderRadius: '100px !important',
    backgroundLinearGradient: '180deg, #F5F6FB 0%, #E4E7EE 100%',
    backgroundColor: '#f8f9fd',
    color: '#1989FF',
    fontFamily: "Open Sans",
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '19px',
    textAlign: 'center',
    border: '7px solid',
    borderColor: '#e6eaf1 !important',
    textTransform: 'none'
  },

  register: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: '700',
    height: '10px'
  },

  registerOk: {
    color: '#828282',
    fontFamily: "Open Sans",
    fontSize: '12px',
    textAlign: 'center',
    fontWeight: '700',
    height: '5px'
  },

  table: {
    fontSize: '10px'
  },

  map: {
    padding: ' 0px 0px !important'
  },

  footer: {
    justifyContent: 'center',
  },

  divRegister: {
    height: '29px'
  },

  gridItem: {
    alignItems: 'center'
  },

  grid: {
    height: '100%'
  },

  text: {
    textAlign: 'center',
    color: '#1989ff',
    fontFamily: "Open Sans",
    fontSize: '26px',
    fontWeight: '400',
    lineHeight: '42px'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px',
    zIndex: 1
  },
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <i className="slick-nav-prev icon-arrow-button-left" onClick={onClick} />
  );
}

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <i className="slick-nav-next icon-arrow-button-right" onClick={onClick} />
  );
}

const useStyles = makeStyles(styles);

export default function Historico() {
  const history = useHistory();
  const classes = useStyles();
  const weekdayshort = moment.weekdaysShort();
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(true);
  const [loadingPage, setLoadingPage] = useState(true);
  const [batidas, setBatidas] = useState([]);
  const [batidasDia, setBatidasDia] = useState([]);
  const [weekdayshortname, setWeekdayshortname] = useState([]);
  const [daysinmonth, setDaysinmonth] = useState([]);
  const [dateObject, setDateObject] = useState(moment());
  const [situacoes, setSituacoes] = useState([]);
  const [feriados, setFeriados] = useState([]);
  const [cpf, setCpf] = useState('');
  const [token, setToken] = useState('');

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  useEffect(() => {
    setLoading(false);
    setLoadingPage(true);
    carregaBatidas();
  }, []);

  useEffect(() => {
    initCalendar();
  }, [dateObject, batidas]);

  const carregaBatidas = async () => {
    try {
      setLoading(true);
      const token = await localStorage.getItem('token');
      const cpf = await localStorage.getItem('cpf');
      setCpf(cpf);
      setToken(token);

      let dados = await api.buscarBatidas(currentMonth(), currentYear());
      if (dados.success) {
        let arrDados = await dados.data?.sort((a, b) => {
          return a.hora?.replace(':', '') - b.hora?.replace(':', '')
        });
        let dataRef = moment(dateObject).format("DD/MM/YYYY");
        let situacoes = await api.getSituacoes(dataRef);
        let feriados = await api.getFeriados(dataRef);
        setBatidasDia([]);
        setSituacoes(situacoes.data);
        setFeriados(feriados.data);
        setBatidas(arrDados);
        initCalendar();
        setLoading(false);
        setLoadingPage(false);
      } else {
        setLoading(false);
        setLoadingPage(false);
        if (dados.statusCode === 401) {
          localStorage.clear();
          history.push("/");
        }
        addToast(dados.message, { appearance: 'error' });
      }
    } catch (err) {
      setLoading(false);
      setLoadingPage(false);
      if (err.statusCode === 401) {
        localStorage.clear();
        history.push("/");
      }
      addToast(err.message, { appearance: 'error' });
    }
  };

  const emitirComprovante = async (batida) => {
    setLoading(true);
    const token = await localStorage.getItem('token');
    const cpf = await localStorage.getItem('cpf');
    let comprovante = await api.emitirComprovante(batida);
    window.open(`${baseURL}/arquivos/download?file=${comprovante}&cpf=${cpf}&token=${token}`, '_blank', 'noreferrer');
    setLoading(false);
  };
  
  const daysInMonth = () => {
    return dateObject.daysInMonth();
  };

  const currentDay = () => {
    return parseInt(dateObject.format("D"));
  };

  const currentMonth = () => {
    return parseInt(dateObject.format("MM"));
  };

  const currentYear = () => {
    return parseInt(dateObject.format("YYYY"));
  };

  const firstDayOfMonth = () => {
    let firstDay = moment(dateObject).startOf("month").format("d"); // Day of week 0...1..5...6
    return firstDay;
  };

  const onPrev = async () => {
    setDateObject(dateObject.subtract(1, "month"));
    setDateObject(dateObject.set('date', 1));
    carregaBatidas();
  };

  const onNext = async () => {
    setDateObject(dateObject.add(1, "month"));
    setDateObject(dateObject.set('date', 1));
    carregaBatidas();
  };

  const onDayClick = async (e, d) => {
    setDateObject(dateObject.set('date', d));
    let arr = await batidas?.filter(a => {
      return a.dia.toString() === d.toString()
    });
    if (arr) {
      setBatidasDia(arr);
    } else {
      setBatidasDia([]);
    }
    initCalendar();
  };

  const getDescricaoStatus = (status) => {
    switch (status) {
      case "X":
        return "Aguardando";
      case "A":
        return "Aprovado";
      case "R":
        return "Recusado";
    }
  }

  const getClasseSituacao = (tipo) => {
    if (tipo === 'FERIAS') return 'ferias';
    if (tipo === 'RESCISAO') return 'rescisao';
    if (['MATERNIDADE', 'AFASTAMENTO', 'AUXDOENCA', 'ACIDTRABALHO'].includes(tipo)) return 'afastamento';
    else return '';
  }

  const initCalendar = async () => {
    let blanks = [];
    for (let i = 0; i < firstDayOfMonth(); i++) {
      blanks.push(<td className="calendar-day empty">{""}</td>);
    }
    let mes = parseInt(moment(dateObject).format("MM"));
    let ano = parseInt(moment(dateObject).format("YYYY"));
    let arrDaysInMonth = [];
    for (let d = 1; d <= daysInMonth(); d++) {
      let curDay = d === currentDay() ? "today" : "";
      let arr = await batidas?.filter(a => {
        return a.dia === d
      });

      if (arr?.length > 0) {
        let day = moment(arr[0].dataPorExtenso.split(".").reverse().join("-"));
        let today = moment(new Date().dateString).format('YYYY-MM-DD');
        if (day.isBefore(today)) {
          let arrBatidas = arr.filter(o => !o.anexo && o.hora || o.anexo && o.hora);
          if (arrBatidas?.length % 2 !== 0) {
            let aHoras = [];
            for (let batida of arr) {
              aHoras.push(batida.hora);
            }
            arr.push({
              dataPorExtenso: arr[0].dataPorExtenso,
              dia: arr[0].dia,
              diaSemana: arr[0].diaSemana,
              warn: true,
              marcacoes: aHoras.join(' - ')
            });
          }
        }
      }

      let dataAtualFmt = moment([ano, mes - 1, d]).format("DD/MM/YYYY");
      let feriado = feriados?.find(objFeriado => objFeriado.dtFeriadoFormatado === dataAtualFmt);
      let situacao = situacoes?.find(objSituacao => objSituacao.data === dataAtualFmt);

      if (feriado) {
        arr.unshift(feriado);
      }
      if (situacao?.situacao) {
        arr.unshift(situacao);
      }
      if (curDay === "today" && arr?.length > 0) {
        setBatidasDia(arr);
      }

      arrDaysInMonth.push(
        <td key={d} className={`calendar-day`} onClick={e => {
          onDayClick(e, d);
        }}>
          <div className={`day-content ${feriado ? 'feriado' : ''} ${situacao?.situacao ? getClasseSituacao(situacao?.situacao.tipo) : ''} ${curDay}`}>
            <span>{d}</span>
            <div className="dots">
              {arr?.map((batida, i) => {
                if (!batida.dtFeriado && !batida.situacao) {
                  if (batida.warn) {
                    return (<label key={i} className="dot batida-faltante"></label>);
                  }
                  else if (batida.justificado === "S") {
                    return (<label key={i} className={`dot ${batida.status === "R" ? 'batida-recusada' : 'batida-justificada'}`}></label>);
                  }
                  else {
                    return (<label key={i} className="dot batida-original"></label>);
                  }
                }
              })}
            </div>
          </div>
        </td>
      );
    }

    var totalSlots = [...blanks, ...arrDaysInMonth];
    let rows = [];
    let cells = [];

    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
      if (i === totalSlots.length - 1) {
        // let insertRow = cells.slice();
        rows.push(cells);
      }
    });

    let daysinmonth = rows.map((d, i) => {
      return <tr key={i}>{d}</tr>;
    });

    let weekdayshortname = weekdayshort.map(day => {
      return <th style={{ height: '35px' }} key={day}>{day}</th>;
    });

    setDaysinmonth(daysinmonth);
    setWeekdayshortname(weekdayshortname);
  }

  const getIconeSituacao = (tipo) => {
    if (tipo === 'FERIAS') return 'icon-beach-palm-water';
    if (tipo === 'MATERNIDADE') return 'icon-baby-trolley';
    if (tipo === 'AFASTAMENTO') return 'icon-school-teacher-wrong';
    if (tipo === 'RESCISAO') return 'icon-single-man-briefcase';
    if (tipo === 'AUXDOENCA') return 'icon-smiley-nose-blow-1';
    if (tipo === 'ACIDTRABALHO') return 'icon-bandage-shoulder';
    else return 'icon-calendar-favorite';
  }

  const getColorIconeSituacao = (tipo) => {
    if (tipo === 'FERIAS') return '#00D684';
    if (tipo === 'RESCISAO') return '#ff3636';
    if (['MATERNIDADE', 'AFASTAMENTO', 'AUXDOENCA', 'ACIDTRABALHO'].includes(tipo)) return '#FF9100';
    else return '#828282';
  }

  const getIconeSituacaoBatida = (status) => {
    if (status === "X") return "icon-calendar-edit";
    if (status === "A") return "icon-calendar-check";
    if (status === "R") return "icon-calendar-disable";
    else return "icon-calendar-check";
  }

  const getColorIconeSituacaoBatida = (status) => {
    if (["X", "A"].includes(status)) return "#1989ff";
    if (status === "R") return "#ff3636";
    else return "#1989ff";
  }

  const getIconeSituacaoAnexo = (status) => {
    if (status === "X") return "icon-common-file-text-edit";
    if (status === "A") return "icon-common-file-text-check";
    if (status === "R") return "icon-common-file-text-remove";
    else return "icon-common-file-text-check";
  }

  if (!loadingPage) {
    return (
      <div className={classes.gridContainer}>
        <GridContainer style={{ position: 'fixed', justifyContent: 'center', height: '100%', alignItems: 'center', zIndex: 1 }} >
          <GridItem>
            <Card style={{
              backgroundColor: '#f8f9fd',
              borderRadius: 25,
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
              borderTopLeftRadius: 25,
              borderTopRightRadius: 25,
              borderColor: '#C8C8C8',
              height: '600px',
              width: '400px',
              boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
            }}>
              <CardHeader style={{ justifyContent: 'center', borderBlockEnd: '1px solid #EEEFF4', textAlign: 'center', height: 270 }}>
                {batidasDia?.length === 0 &&
                  <div style={{ position: 'absolute', left: '50%', top: '15%', transform: 'translate(-50%, -15%)', display: 'grid' }}>
                    <i className="icon-calendar-block" style={{ fontSize: 42, color: '#1989ff', marginBottom: 10 }} />
                    <span style={{ color: '#1989ff', fontSize: 16, fontWeight: 400 }}>Nenhum registro de ponto efetuado para este dia</span>
                  </div>}

                {batidasDia?.length > 0 &&
                  <Slider {...settings}>
                    {batidasDia?.map((batida, i) => {
                      if (batida.situacao) {
                        return (
                          <div key={i}>
                            <div className='slider-content'>
                              <div style={{ display: 'grid' }}>
                                <i className={getIconeSituacao(batida.situacao.tipo)} style={{ fontSize: 24, color: getColorIconeSituacao(batida.situacao.tipo), marginBottom: 6 }} />
                                <label style={{ fontWeight: 700, color: '#909090', margin: 0, lineHeight: '20px' }}>{`${moment(batida.data?.split('/').reverse().join('-')).format('dddd')}, ${moment(batida.data?.split('/').reverse().join('-')).format('D')}`}</label>
                                <label style={{ color: '#828282', margin: 0, lineHeight: '25px', fontSize: 12 }}>SITUAÇÃO</label>
                                <label style={{ fontWeight: 600, color: getColorIconeSituacao(batida.situacao.tipo), fontSize: 22, margin: 0, lineHeight: '25px' }}>{batida.situacao.descricao}</label>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      else if (batida.dtFeriado) {
                        return (
                          <div key={i}>
                            <div className='slider-content'>
                              <div style={{ display: 'grid' }}>
                                <i className="icon-calendar-favorite" style={{ fontSize: 24, color: '#8f1ea3', marginBottom: 6 }} />
                                <label style={{ fontWeight: 700, color: '#909090', margin: 0, lineHeight: '20px' }}>{`${moment(batida.dtFeriadoFormatado?.split('/').reverse().join('-')).format('dddd')}, ${moment(batida.dtFeriadoFormatado?.split('/').reverse().join('-')).format('D')}`}</label>
                                <label style={{ color: '#828282', margin: 0, lineHeight: '25px', fontSize: 12 }}>FERIADO</label>
                                <label style={{ fontWeight: 600, color: '#8f1ea3', fontSize: 22, margin: 0, lineHeight: '25px' }}>{batida.descricao}</label>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      else if (batida.warn) {
                        return (
                          <div key={i}>
                            <div className='slider-content'>
                              <div style={{ display: 'grid' }}>
                                <i className="icon-road-sign-warning" style={{ fontSize: 24, color: '#FF9100', marginBottom: 6 }} />
                                <label style={{ fontWeight: 700, color: '#909090', margin: 0, lineHeight: '20px' }}>{`${batida.diaSemana},${batida.dia}`}</label>
                                <label style={{ fontWeight: 600, color: '#FF9100', fontSize: 28, margin: 0, lineHeight: '35px' }}>Sem Registro :(</label>
                                <label style={{ color: '#909090', margin: 0, lineHeight: '35px', fontSize: 14 }}>Ocorreu algum imprevisto?</label>
                                <label style={{ color: '#909090', margin: 0, lineHeight: '5px', fontSize: 14 }}>Justifique sua ausência no botão abaixo!</label>
                                <GridItem style={{ justifyContent: 'center', alignItems: 'baseline', display: 'grid', padding: 0, marginTop: 10, paddingBottom: 100 }}>
                                  <a className='button-round' color="primary" style={{ backgroundColor: '#ff9100', cursor: 'pointer' }} onClick={() => history.push('/justificativa', { data: batida.dataPorExtenso, marcacoes: batida.marcacoes })}>Justificar Ausência</a>
                                </GridItem>
                              </div>
                            </div>
                          </div>
                        )
                      }
                      else if (batida.anexo) {
                        return (
                          <div key={i}>
                            <div className='slider-content'>
                              <div style={{ display: 'grid' }}>
                                <i className={getIconeSituacaoAnexo(batida.status)} style={{ fontSize: 24, color: getColorIconeSituacaoBatida(batida.status), marginBottom: 6 }} />
                                <label style={{ fontWeight: 700, color: '#909090', margin: 0, lineHeight: '20px' }}>{`${batida.diaSemana},${batida.dia}`}</label>
                                {batida.hora && <label style={batida.status === "R" ? { color: '#ff3636', fontWeight: 600, fontSize: 42, margin: 0, lineHeight: '50px' } : { color: '#1989ff', fontWeight: 600, fontSize: 42, margin: 0, lineHeight: '50px' }}>{batida.hora}</label>}
                                {!batida.hora && <label style={batida.status === "R" ? { color: '#ff3636', fontWeight: 600, fontSize: 30, margin: 0, lineHeight: '40px' } : { color: '#1989ff', fontWeight: 600, fontSize: 30, margin: 0, lineHeight: '40px' }}>ATESTADO</label>}
                                {batida.status && <label style={{ color: '#909090', margin: 0, lineHeight: '20px' }}>Status: {getDescricaoStatus(batida.status)}</label>}
                                <label style={{ color: '#cccccc', margin: 0, lineHeight: '20px' }}>DOC: {batida._id}</label>                                                               
                                <Button style={{ borderRadius: '25px', fontWeight: 700, fontSize: 15, color: '#1989ff', backgroundColor: '#f8f9fd', width: 200, height: 20 }} onClick={() => emitirComprovante(batida)} color="primary">Emitir Comprovante</Button>                                
                                <GridItem style={{ justifyContent: 'center', alignItems: 'baseline', display: 'grid', padding: 0, marginTop: 0 }}>
                                  <a href={`${baseURL}/arquivos/download?file=${batida.anexo}&cpf=${cpf}&token=${token}`} className='button-round' color="primary" style={batida.status === "R" ? { backgroundColor: '#ff3636', width: 125 } : { backgroundColor: '#1989ff', width: 125 }}>Baixar Anexo</a>
                                </GridItem>
                              </div>
                            </div>
                          </div>
                        )
                      } else {
                        return (
                          <div key={i}>
                            <div className='slider-content'>
                              <div style={{ display: 'grid' }}>
                                <i className={getIconeSituacaoBatida(batida.status)} style={{ fontSize: 24, color: getColorIconeSituacaoBatida(batida.status), marginBottom: 6 }} />
                                <label style={{ fontWeight: 700, color: '#909090', margin: 0, lineHeight: '20px' }}>{`${batida.diaSemana},${batida.dia}`}</label>
                                {batida.hora && <label style={batida.status === "R" ? { color: '#ff3636', fontWeight: 600, fontSize: 42, margin: 0, lineHeight: '50px' } : { color: '#1989ff', fontWeight: 600, fontSize: 42, margin: 0, lineHeight: '50px' }}>{batida.hora}</label>}
                                {!batida.hora && <label style={batida.status === "R" ? { color: '#ff3636', fontWeight: 600, fontSize: 30, margin: 0, lineHeight: '40px' } : { color: '#1989ff', fontWeight: 600, fontSize: 30, margin: 0, lineHeight: '40px' }}>ATESTADO</label>}
                                {batida.status && <label style={{ color: '#909090', margin: 0, lineHeight: '20px' }}>Status: {getDescricaoStatus(batida.status)}</label>}
                                <label style={{ color: '#cccccc', margin: 0, lineHeight: '20px' }}>DOC: {batida._id}</label>
                                <Button style={{ borderRadius: '25px', fontWeight: 700, fontSize: 15, color: '#1989ff', backgroundColor: '#f8f9fd', width: 200, height: 20 }} onClick={() => emitirComprovante(batida)} color="primary">Emitir Comprovante</Button>
                                {batida.motivoRecusa && <GridItem style={{ justifyContent: 'center', alignItems: 'baseline', display: 'grid', padding: 0, marginTop: -4 }}>
                                  <a className='button-round' style={{ backgroundColor: '#ff3636', cursor: 'pointer' }} color="primary" onClick={() => {
                                    confirmAlert({
                                      closeOnEscape: false,
                                      closeOnClickOutside: false,
                                      title: (
                                        <div>
                                          <i className='icon-calendar-disable' style={{ fontSize: '52px', color: '#FFFFFF', marginBottom: 60 }} />
                                          <h5 style={{ marginTop: 30 }}>{'Motivo da Recusa'}</h5>
                                        </div>
                                      ),
                                      message: (
                                        <h3 style={{ marginBottom: 30 }}>{batida.motivoRecusa}</h3>
                                      ),
                                      buttons: [
                                        {
                                          label: 'Ok',
                                          onClick: () => { }
                                        }
                                      ]
                                    });
                                  }}>Visualizar Motivo</a>
                                </GridItem>}
                              </div>
                            </div>
                          </div>
                        )
                      }
                    })}
                  </Slider>}
              </CardHeader>

              <CardBody style={{ padding: '10px', paddingTop: '15px', flex: 'inherited' }}>
                <div className="tail-datetime-calendar">
                  <div className="calendar-navi">
                    <i className="calendar-button icon-arrow-button-left" onClick={e => onPrev()} />

                    <span className="calendar-label">
                      {`${dateObject.format('MMMM')} ${dateObject.format('Y')}`}
                    </span>

                    <i className="calendar-button icon-arrow-button-right" onClick={e => onNext()} />
                  </div>

                  <div className="calendar-date">
                    <table className="calendar-day">
                      <thead>
                        <tr>{weekdayshortname}</tr>
                      </thead>
                      <tbody>{daysinmonth}</tbody>
                    </table>
                  </div>
                </div>
              </CardBody>

              <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <ClipLoader
                  size={80}
                  color={"#364e6b"}
                  loading={loading}
                  css={{ border: '8px solid', borderBottomColor: 'transparent' }}
                />
              </div>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  } else {
    return (
      <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
        <ClipLoader
          size={80}
          color={"#364e6b"}
          loading={true}
          css={{ border: '8px solid', borderBottomColor: 'transparent' }}
        />
      </div>
    );
  }
}
